import React, { useEffect, useState } from 'react';

/**
 * Shared avatar shell: a circular flex container that shows `src` as a
 * cover-fit image and falls back to `fallback` (over a `bg` fill) when there is
 * no src or the image fails to load. Extracted from UserAvatar and ChannelAvatar
 * so both share one image/fallback/overlay implementation.
 *
 * Callers own their own sizing — pass a `sizeStyle` object (e.g. width/height,
 * and for user avatars a derived fontSize) so each keeps its exact rendering.
 */
export default function AvatarShell({
  src,
  bg,
  fallback,
  sizeStyle = {},
  className = '',
  style = {},
  children,
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const showImage = src && !failed;

  return (
    <div
      className={className}
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        borderRadius: '50%',
        color: '#fff',
        fontWeight: 600,
        ...sizeStyle,
        background: showImage ? 'transparent' : bg,
        ...style,
      }}
    >
      {showImage ? (
        <img
          src={src}
          alt=""
          draggable={false}
          onError={() => setFailed(true)}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
      ) : (
        fallback
      )}
      {children}
    </div>
  );
}
